import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { highlightColumnColor } from '../../utils/dashboardCalculations';

function getHealthScoreVisuals(score) {
    console.log("line no 6 team",score);

    if (score >= 8 && score <= 10) {
        return {
            status: 'Optimal Health',
            background: 'cardSpreadDarkGreen',
        };
    } else if (score >= 6 && score < 8) {
        return {
            status: 'Good Health',
            background: 'cardSpreadGreen',
        };
    } else if (score >= 4 && score < 6) {
        return {
            status: 'Moderate Health',
            background: 'cardSpreadYellow',
        };
    } else if (score >= 0 && score < 4) {
        return {
            status: 'Poor Health',
            background: 'cardSpreadRed',
        };
    } else {
        return {
            status: 'Unknown',
            background: '',
        };
    }
}

class teamHealthScore extends Component {
	componentDidMount() {}
	
	render() {
		const { team } = this.props;
		const highlightColor = highlightColumnColor(team.team_gaming_score, 'cardSpread');
		const healthScoreVisuals 	= getHealthScoreVisuals(team.team_gaming_score || '10');		
		const highlightColorA 		= healthScoreVisuals.background;
		return (
			<div>
				<Row className='cardSpreadRow'>
					<Col lg={12} className={`cardHighlight ${highlightColorA}`}>
						<div className='cardSpreadDiv'>
							<h4 className='cardSpread'>
								<span className='cardSpreadNoBetText'>Team Health Score</span>
								<span className='cardSpreadNumberTeam'>{team.team_gaming_score || '10'}</span>
							</h4>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}

export default teamHealthScore;
